const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Directorio de Profesionales y Especialistas",
    summary:
      "Gestiona el equipo de profesionales y colaboradores encargados de la atención. Configura sus datos de contacto, servicios que prestan y horarios de disponibilidad semanal para la asignación de citas en la agenda.",
  },
  sections: [
    {
      id: "ficha_profesional",
      title: "1. Ficha del Profesional y Datos de Contacto",
      description:
        "Registro y credenciales de cada miembro del equipo.",
      items: [
        {
          id: "identificacion",
          title: "Nombre, Correo y Especialidad",
          definition:
            "Datos identificatorios visibles en el calendario interno y en la ficha de selección que visualiza el cliente al reservar su cita.",
        },
        {
          id: "servicios_asociados",
          title: "Servicios Habilitados",
          definition:
            "Selecciona qué servicios de tu catálogo puede atender este profesional para limitar las opciones de reserva exclusivamente a sus competencias.",
        },
      ],
    },
    {
      id: "jornada_laboral",
      title: "2. Horarios y Disponibilidad Semanal",
      description:
        "Planificación de turnos de trabajo y descansos.",
      items: [
        {
          id: "horario_atencion",
          title: "Configuración de Días y Horas",
          definition:
            "Define las franjas horarias en las que el especialista atiende (ej: Lunes a Viernes de 09:00 a 18:00). La agenda bloqueará automáticamente los horarios fuera de su jornada.",
        },
        {
          id: "coordinacion_citas",
          title: "Capacidad por Especialista",
          definition:
            "Evita la superposición de citas asegurando que ningún profesional reciba dos consultas simultáneas en el mismo intervalo de tiempo.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Professionals & Specialists Directory",
    summary:
      "Manage your roster of professionals, doctors, and service specialists. Configure staff profiles, associated services, and weekly working hours to coordinate booking distribution across your calendar.",
  },
  sections: [
    {
      id: "ficha_profesional",
      title: "1. Staff Profile & Contact Credentials",
      description:
        "Profile setup for each service provider.",
      items: [
        {
          id: "identificacion",
          title: "Full Name, Email & Role",
          definition:
            "Staff identity rendered on internal scheduling dashboards and shown to clients during online booking selection.",
        },
        {
          id: "servicios_asociados",
          title: "Assigned Service Capabilities",
          definition:
            "Check which catalog services this staff member is authorized to perform, ensuring clients can only book them for valid treatments.",
        },
      ],
    },
    {
      id: "jornada_laboral",
      title: "2. Working Shifts & Availability",
      description:
        "Shift scheduling and off-time management.",
      items: [
        {
          id: "horario_atencion",
          title: "Weekly Hours & Day Slots",
          definition:
            "Set specific shift hours (e.g., Mon–Fri 09:00 to 18:00). The booking system automatically hides times outside their working shift.",
        },
        {
          id: "coordinacion_citas",
          title: "Double-Booking Prevention",
          definition:
            "Guarantees conflict-free scheduling by preventing overlapping appointment bookings for the same professional.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Diretório de Profissionais e Especialistas",
    summary:
      "Gerencie a equipe de colaboradores e profissionais responsáveis pelos atendimentos. Cadastre dados de contato, serviços atendidos e horários de disponibilidade semanal para a distribuição organizada de consultas.",
  },
  sections: [
    {
      id: "ficha_profesional",
      title: "1. Cadastro do Profissional e Contatos",
      description:
        "Identificação e qualificações de cada membro da equipe.",
      items: [
        {
          id: "identificacion",
          title: "Nome, E-mail e Especialidade",
          definition:
            "Dados de identificação visíveis na agenda interna e na tela pública de agendamento acessada pelo cliente.",
        },
        {
          id: "servicios_asociados",
          title: "Serviços Habilitados",
          definition:
            "Defina quais procedimentos do catálogo esse especialista realiza, restringindo as reservas apenas às suas especialidades.",
        },
      ],
    },
    {
      id: "jornada_laboral",
      title: "2. Jornada de Trabalho e Horários",
      description:
        "Controle de turnos semanais e períodos de descanso.",
      items: [
        {
          id: "horario_atencion",
          title: "Definição de Dias e Horários de Atendimento",
          definition:
            "Configure as faixas de horário em que o profissional atende (ex: Seg a Sex das 09:00 às 18:00). O sistema bloqueia automaticamente horários fora do turno.",
        },
        {
          id: "coordinacion_citas",
          title: "Prevenção de Conflitos na Agenda",
          definition:
            "Garante que nenhum especialista receba dois agendamentos no mesmo horário simultaneamente.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Annuaire des Professionnels et Praticiens",
    summary:
      "Gérez l'équipe de collaborateurs et spécialistes en charge des rendez-vous. Renseignez leurs coordonnées, prestations associées et plages de travail hebdomadaires pour planifier les consultations sans friction.",
  },
  sections: [
    {
      id: "ficha_profesional",
      title: "1. Fiche Praticien et Coordonnées",
      description:
        "Profil et qualifications de chaque membre de l'équipe.",
      items: [
        {
          id: "identificacion",
          title: "Nom, E-mail et Spécialité",
          definition:
            "Informations d'identification affichées sur l'agenda interne et sur le portail de prise de rendez-vous en ligne.",
        },
        {
          id: "servicios_asociados",
          title: "Prestations Autorisées",
          definition:
            "Sélectionnez les services du catalogue pris en charge par ce professionnel afin de garantir des réservations conformes à ses compétences.",
        },
      ],
    },
    {
      id: "jornada_laboral",
      title: "2. Plages de Disponibilité et Planning",
      description:
        "Organisation des plannings de travail et des temps de repos.",
      items: [
        {
          id: "horario_atencion",
          title: "Horaires Hebdomadaires d'Exercice",
          definition:
            "Définissez les créneaux d'activité du praticien (ex: Lundi au Vendredi de 09h00 à 18h00). Les créneaux hors shift sont masqués à la réservation.",
        },
        {
          id: "coordinacion_citas",
          title: "Protection contre les Doublons",
          definition:
            "Empêche tout chevauchement de rendez-vous pour un même intervenant sur une même plage horaire.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "دليل الأخصائيين والمهنيين",
    summary:
      "إدارة شاملة لفريق العمل والأخصائيين المسؤولين عن تقديم الخدمات. يتيح ضبط بيانات التواصل، الخدمات المؤهلين لتقديمها، ومواعيد العمل الأسبوعية لتنظيم جدول الحجوزات بسلاسة.",
  },
  sections: [
    {
      id: "ficha_profesional",
      title: "1. الملف التعريفي وبيانات الأخصائي",
      description:
        "إعداد وتأهيل أعضاء الفريق لتقديم الخدمات.",
      items: [
        {
          id: "identificacion",
          title: "الاسم الكامل، البريد الإلكتروني والتخصص",
          definition:
            "بيانات تعريفية تظهر في التقويم الداخلي وللعميل أثناء اختياره للأخصائي المفضل في صفحة الحجز الذاتي.",
        },
        {
          id: "servicios_asociados",
          title: "الخدمات المعتمدة للأخصائي",
          definition:
            "تحديد الخدمات التي يقدمها هذا الأخصائي من دليل الخدمات، لمنع حجز خدمات غير مناسبة لتخصصه.",
        },
      ],
    },
    {
      id: "jornada_laboral",
      title: "2. أوقات العمل والجدول الأسبوعي",
      description:
        "تنظيم الورديات وفترات الدوام والراحة.",
      items: [
        {
          id: "horario_atencion",
          title: "ضبط ساعات وأيام العمل",
          definition:
            "تحديد الفترات الزمنية لدوام الأخصائي (مثل: الإثنين إلى الجمعة من 09:00 إلى 18:00). يقوم النظام بحظر أي حجز خارج أوقات الدوام تلقائياً.",
        },
        {
          id: "coordinacion_citas",
          title: "منع تعارض المواعيد المزدوجة",
          definition:
            "ضمان عدم تسجيل موعدين متطابقين في نفس الوقت لنفس الأخصائي منعاً للازدحام.",
        },
      ],
    },
  ],
};

export const PROFESSIONALS_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
